<div *ngIf="((!(hasViewMoneyAccess$ | async) && (authorizedFinished$ | async)) || (authorizedFailed$ | async))" id="setup-eAuthorization-content">
    <mm-view-move-money-page></mm-view-move-money-page>
</div>
<div *ngIf="(hasViewMoneyAccess$ | async)" id="setup-eAuthorization-content">
<div *ngIf="accountInContext else legacyRedirect;">
    <mm-banners *ngIf="(hasEauthClientsServiceError$ | async)" [bannerText]="[serviceErrorMessage]" [type]="'error'"></mm-banners>
    <mm-account-info-header [accountInfo]="accountInfo"></mm-account-info-header>
    <mm-eAuthorization-page></mm-eAuthorization-page>
</div>
</div>
<ng-template #legacyRedirect>
    <mm-legacy-redirect-landing-page></mm-legacy-redirect-landing-page>
</ng-template>